module.exports = __webpack_public_path__ + "img/LAVAGE.9c47272e.png";